import { money } from "./policy";
import type { Deferral } from "./types";

/**
 * Наценка за отсрочку постоплаты.
 *
 * Из шапки шаблона ООО:
 *   для клиента (max)  O16 = Итого с НДС × (1 − аванс) × ключевая ставка × дни / 365
 *   для нас (min)      N18 = (Себестоимость − Итого с НДС × аванс) × ставка × дни / 365
 *
 * Первая величина — сколько запросить с клиента, вторая — во сколько отсрочка
 * обходится агентству. В таблице наценка живёт отдельной строкой перед итогом,
 * так что расчёт не растворяется внутри блоков.
 */
export function calcDeferral(
  deferral: Deferral,
  totals: { gross: number; cost: number },
): { client: number; own: number } {
  if (!deferral.enabled || deferral.days <= 0) return { client: 0, own: 0 };

  // Дни и ставка — неотрицательные: «минус тридцать дней отсрочки» означало
  // наценку клиенту со знаком минус, то есть скидку за то, чего не было.
  const k = (Math.max(0, deferral.keyRate) * deferral.days) / 365;
  // Аванс — доля от нуля до единицы. Больше единицы наценка клиенту уходила
  // в минус: экран такого не пропускает, но ядро считает всё, что ему дали,
  // а даёт ему не только экран.
  const advance = Math.min(1, Math.max(0, deferral.advanceShare));
  const client = totals.gross * (1 - advance) * k;
  const own = (totals.cost - totals.gross * advance) * k;

  return { client: money(client), own: money(Math.max(own, 0)) };
}
